export const requiredFileLists: any = [
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    }
];

export const fileLists: any = [
    //NIGERIAN BAR ASSOCIATION
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Evidence of Identification',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Qualifying Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'NYSC Discharge Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/IND',
        'required': false,
        'progress': ''
    },
    {
        'docName': 'Current Practicing Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/IND',
        'required': true,
        'progress': ''
    },

    //NIGERIAN BAR ASSOCIATION FIRM
    //Note: Maximum of three representatives that must be lawyers 
    {
        'docName': 'Qualifying Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'NYSC Discharge Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/FM',
        'required': false,
        'progress': ''
    },
    {
        'docName': 'Current Practicing Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Signature Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NBA/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Certificate Of Registration Of The Firm',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/FM',
        'required': true,
        'progress': ''
    },

    //NIGERIAN BAR ASSOCIATION
    //NYSC
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NYSC/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'NYSC/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Evidence of Identification',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/NYSC',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Qualifying Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/NYSC',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Current Practicing Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/NYSC',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Introduction Letter From Primary Place Of Assignment',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'NBA/NYSC',
        'required': true,
        'progress': ''
    },

    //ICAN
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Evidence of Identification',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Subscription Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICAN/IND',
        'required': true,
        'progress': ''
    },

    //ICAN FIRM
    //Note: Maximum of three representatives that must be chartered accountants
    {
        'docName': 'Subscription Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph Of Representative',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Signature Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Certificate Of Registration Of The Firm',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICAN/FM',
        'required': true,
        'progress': ''
    },

    //ANAN
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ANAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ANAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Evidence of Identification',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ANAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Subscription Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ANAN/IND',
        'required': true,
        'progress': ''
    },

    //ANAN FIRM
    //Note: Maximum of three representatives that must be chartered accountants
    {
        'docName': 'Signature Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ANAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ANAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'ANAN Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ANAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Subscription Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ANAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Certificate Of Registration Of The Firm',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ANAN/FM',
        'required': true,
        'progress': ''
    },


    //THE INSTITUTE OF CHARTERED SECRETARIES AND ADMINISTRATORS OF NIGERIA
    //ICSAN
    {
        'docName': 'Signature',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICSAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICSAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Evidence of Identification',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICSAN/IND',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Memebership Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICSAN/IND',
        'required': true,
        'progress': ''
    },

    //ICSAN FIRM
    //Note: Maximum of three representatives that must be chartered accountants
    {
        'docName': 'Signature Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICSAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'A Passport Photograph Of Representative',
        'fileType': 'JPEG IMAGE',
        'fileExtension': '.jpg,.jpeg',
        'userType': 'ICSAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Membership Certificate',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICSAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Subscription Fee Receipt',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICSAN/FM',
        'required': true,
        'progress': ''
    },
    {
        'docName': 'Certificate Of Registration Of The Firm',
        'fileType': 'PDF',
        'fileExtension': '.pdf',
        'userType': 'ICSAN/FM',
        'required': true,
        'progress': ''
    },

]